module.exports = __webpack_public_path__ + "static/media/dinosaur.d4660415.jpg";